import styled from "styled-components";

export const ProgressBarContainer = styled.div`
    height: 0.125rem;
    width: 100%;
    background: rgba(196, 177, 128, 0.30);
    position: fixed;
    top: 6.5rem;
`

export const ProgressBarItem = styled.div`
    background: #C4B180;
    height: 0.125rem;
    width: ${props => props.progressPercentage}%;
`